import { FC } from "react";
import { Button, Sheet, Typography } from "@mui/joy";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { barItems } from "../organism/constant";

export const Navbar: FC = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <Sheet
      variant="outlined"
      sx={{
        position: "fixed",
        bottom: 14,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 60,
        display: { xs: "flex", lg: "none" },
        alignItems: "center",
        gap: 0.5,
        p: 0.75,
        maxWidth: "calc(100vw - 24px)",
        overflowX: "auto",
        borderRadius: "999px",
        bgcolor: "background.surface",
        backdropFilter: "blur(18px)",
        boxShadow: "lg",
      }}
    >
      {barItems.map(({ title, icon: Icon, path }) => {
        const active = path === pathname;

        return (
          <Button
            key={title}
            component={Link as any}
            to={path}
            size="sm"
            color={active ? "primary" : "neutral"}
            variant={active ? "solid" : "plain"}
            sx={{
              minWidth: { xs: 52, sm: 78 },
              px: { xs: 1, sm: 1.5 },
              flexDirection: "column",
              gap: 0.25,
              borderRadius: "999px",
              whiteSpace: "nowrap",
            }}
          >
            <Icon style={{ fontSize: 20 }} />
            <Typography
              level="body-xs"
              sx={{
                display: { xs: "none", sm: "block" },
                color: "inherit",
                fontWeight: 800,
              }}
            >
              {t(title).charAt(0).toUpperCase() + t(title).slice(1)}
            </Typography>
          </Button>
        );
      })}
    </Sheet>
  );
};
